exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.search[data-v-3fd5138e]{max-width:500px\n}\n.orderby[data-v-3fd5138e]{max-width:200px\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/elements/search-toolbar.vue"],"names":[],"mappings":";AAAA,yBAAQ,eAAe;CAAC;AAAA,0BAAS,eAAe;CAAC","file":"search-toolbar.vue","sourcesContent":[".search{max-width:500px}.orderby{max-width:200px}\n"],"sourceRoot":""}]);

// exports
